import { render, staticRenderFns } from "./CommunityContact.vue?vue&type=template&id=0e70e3af&scoped=true"
import script from "./CommunityContact.vue?vue&type=script&lang=js"
export * from "./CommunityContact.vue?vue&type=script&lang=js"
import style0 from "./CommunityContact.vue?vue&type=style&index=0&id=0e70e3af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70e3af",
  null
  
)

export default component.exports